<template>
  <div>
    <div class="workList workList1" v-if="!pageShow">
      <div class="work-item">
        <div style="text-align:right;">
          <el-button type="success" @click="editWork(undefined,true)" icon="el-icon-document-add"
                     style="background-color:#39C1C2;padding: 10px 15px;">作品申报
          </el-button>
        </div>
      </div>
      <div v-for="(item) in temporaryWorkList" :key="item.id">
        <div class="work-item">
          <el-row :gutter="10">
            <el-col :span="17">
              <div class="works_table_list">
                <el-row :gutter="20" class="subText">
                  <el-col :lg="12" :xs="24" :xl="24">
                    <span>作品编号：{{ item.id }}</span>
                  </el-col>
                  <el-col :lg="12" :xs="24" :xl="24">
                    <span>赛题组：{{ getTypeName(item.categoryId) }}(暂存作品)</span>
                  </el-col>
                  <el-col :lg="12" :xs="24" :xl="24">
                    <span>提交时间：{{ item.createTime }}</span>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="7">
              <el-col :lg="12" :xs="24">
                <el-button
                  type="success"
                  @click="editWork({
                  workDynamicData:item
                  },true)"
                  style="background-color:#39C1C2;padding: 15px 15px"
                  size="mini"
                >查看详情
                </el-button>
              </el-col>
              <el-col :lg="12" :xs="24">
                <el-button
                  type="danger"
                  @click="deleteTemporaryWork(item)"
                  style="padding: 15px 15px"
                  size="mini"
                >删除
                </el-button>
              </el-col>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="enWorkList-el-divider-Div">
        <el-divider content-position="center">正式作品</el-divider>
      </div>
      <div v-for="(item, index) in list" :key="index">
        <div  class="work-item">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="6" :md="17" :lg="17" :xl="17">
              <div>
                <el-row :gutter="20" class="subText">
                  <el-col :lg="12" :xs="24">
                    <span>作品编号：{{ item.workDynamicData.id }}</span>
                  </el-col>
                  <el-col :lg="12" :xs="24">
                    <span>赛题组：{{ getTypeName(item.workDynamicData.categoryId) }}</span>
                  </el-col>
                  <el-col :lg="12" :xs="24">
                    <span>提交时间：{{ item.workDynamicData.createTime }}</span>
                  </el-col>
                  <el-col :lg="12" :xs="24">
                    <span>作品状态：{{ formate(item.workDynamicData.flowId) }}</span>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :xs="12" :sm="6" :md="4" :lg="4" :xl="4">
              <el-button type="success" @click="editWork(item,false)"
                         style="background-color:#39C1C2;padding: 10px 15px" size="mini">查看详情
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div class="action-item">
          操作：
          <el-button @click="addFlow(action,item)" :key="index" v-for="(action,index) in item.actionList" type="primary"
                     size="small">{{ action.label }}
          </el-button>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="flowFalg"
      :title="currentFlow.action?
      currentFlow.action.isNotice?`${currentFlow.action.label}(当前操作需要推送消息，请填写消息推送信息)`:currentFlow.action.label
      :''"
      :visible.sync="flowFalg"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="60%">
      <work-form style="text-align: left" v-if="flowFalg" ref="workFormCheck" :language="'cn'" @updataWorkStatus="updataWorkStatus"
                 :work-type-list="workTypeList" :disabled-falg="false"
                 :form-type="form.categoryId" :form-obj="form" :site-id="this.siteId"
                 :division-id="form.divisionId"></work-form>
      <el-divider v-if="currentFlow.action?currentFlow.action.isNotice:false" content-position="left">推送内容
      </el-divider>
      <el-form v-if="currentFlow.action?currentFlow.action.isNotice:false" :model="pushFlow" ref="flowForm"
               label-width="0px" :rules="flowRules">
        <el-form-item label="" prop="pushMsg">
          <el-input type="textarea" v-model="pushFlow.pushMsg" :autosize="{ minRows: 4, maxRows: 4}"
                    placeholder="当前操作需要推送消息给相关用户，请填写消息推送信息"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                  <el-popconfirm v-if="flowFalg" @onConfirm="addFlowByMsg()" @confirm="addFlowByMsg()"
                                 title="您确认要执行本次操作吗？">
          <el-button
            :disabled="addFlowFalg"
            style="margin-right: 10px"
            type="primary"
            slot="reference"
            icon="el-icon-s-check">
            {{ currentFlow.action ? currentFlow.action.label : '' }}
          </el-button>
        </el-popconfirm>
          <el-button @click="flowFalg = false">取 消</el-button>
        </span>
    </el-dialog>
    <div v-if="pageShow">
      <work-form :temporary-falg="temporaryFalg" :work-type-list="workTypeList" @back="back" :language="'cn'"  :disabled-falg="workEditFalg"
                 :form-type="form.categoryId" :form-obj="form" :site-id="this.siteId"
                 :division-id="form.divisionId"></work-form>
    </div>
  </div>
</template>

<script>
import {
  delData,
  getContWorkDynamicDataFlowVoById,
  listData,
  listTemporary,
  removeTemporary, updateFlowId
} from '../../../api/work/workdata'
import {listWorksCategoryConf} from '../../../api/work/worksCategoryConf'
import WorkForm from '../../../components/workForm'
import {conditionByParticipantData} from '../../../api/registerForm'

export default {
  components: {WorkForm},
  props: ['status'],
  data () {
    return {
      updataWorkFalg: false,
      addFlowFalg: false,
      currentFlow: {},
      pushFlow: {
        pushMsg: ''
      },
      flowFalg: false,
      workId: null,
      user: null,
      workEditFalg: false,
      temporaryFalg: true,
      temporaryWorkList: [],
      list: [],
      workTypeList: [],
      pageShow: false,
      form: {},
      flowRules: {
        pushMsg: [
          {required: true, message: '请输入要推送的内容', trigger: 'blur'}
        ]
      }
    }
  },
  mounted () {
    if (!this.$store.state.user) {
      this.loginVisible = true
    } else {
      this.getWorkType()
    }
  },
  watch: {
    pageShow (newVal, oldVal) {
      if (this.$store.state.user && !newVal) {
        this.getWorkType()
      }
    }
  },
  methods: {
    updateFlow (falg) {
      return new Promise((resolve, reject) => {
        updateFlowId(this.siteURL, {
          workDynamicData: {
            id: this.currentFlow.row.workDynamicData.id,
            flowId: this.currentFlow.action.targetId,
            sourceId: this.currentFlow.action.sourceId
          },
          msgDomain: {
            isNotice: falg, // 是否发送通知
            msg: this.pushFlow.pushMsg, // 消息内容
            sourceId: this.currentFlow.action.sourceId, // 源节点id
            targetId: this.currentFlow.action.targetId, // 目标节点id
            siteId: this.siteId, // 站点id
            senderName: this.name, // 用户名
            type: 4, // 作品消息提醒
            authorId: this.form.userId,
            workId: this.form.id
          }
        }).then(res => {
          this.addFlowFalg = false
          resolve()
        }).catch(e => {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject()
          this.addFlowFalg = false
        })
      })
    },
    formate(nodeId){
      if (nodeId !== undefined) {
        if (nodeId === 'node-0.837065439880671673947256266') {
          return '初赛通过'
        } else if (nodeId === 'node-0.479304549482943541673947255585') {
          return '初赛未通过'
        } else if (nodeId === 'node-0.55711796314815031673947861269') {
          return '初赛材料修改'
        } else if (nodeId === 'node-0.70515427515176031673949099896') {
          return '复赛未通过'
        } else if (nodeId === 'node-0.25713397678551731673949110615') {
          return '复赛通过'
        } else if (nodeId === 'node-0.365944282789430031673948940912') {
          return '复赛材料修改'
        } else {
          return '待审核'
        }
      } else {
        return '待审核'
      }
    },
    addFlowByMsg () {
      console.log('in addFlowByMsg')
      console.log('updataWorkFalg: ' + this.updataWorkFalg)
      if (this.updataWorkFalg) {
        this.commitWork()
      } else {
        this.$confirm('系统检测到对修改内容未进行保存，是否提交', '确认信息', {
          distinguishCancelAndClose: true,
          confirmButtonText: '提交',
          cancelButtonText: '取消'
        }).then(() => {
          this.commitWork()
        }).catch(action => {
          return
        })
      }
    },
    commitWork () {
      console.log('in commitWork')
      if (this.$refs.flowForm) {
        console.log('this.$refs.flowForm: ' + this.$refs.flowForm)
        this.addFlowFalg = true
        this.$refs.flowForm.validate((valid) => {
          if (valid) {
            this.updateFlow(true).then(() => {
              this.$message.success('操作成功')
              this.initView()
            }).catch((error) => {
              this.$message.error('流程信息提交出错，请联系管理员')
              this.initView()
            })
          } else {
            this.addFlowFalg = false
          }
        })
      } else {
        console.log('this.$refs.flowForm else: ' + this.$refs.flowForm)
        this.updateFlow(false).then(() => {
          this.$message.success('操作成功')
          this.initView()
        }).catch((error) => {
          this.$message.error('流程信息提交出错，请联系管理员')
          this.initView()
        })
      }
    },
    initView () {
      this.flowFalg = false
      this.getWorkType()
    },
    async addFlow (action, row) {
      if (row.nodeList[0].nodeType === 'file-check') {
        /* this.$message(
          {
            message: '您的作品不符合规则，进行操作前请按照审核意见重新修改作品，具体情况请查看个人消息',
            type: 'info',
            customClass: 'mzindex'
          }
        ) */
      }
      await getContWorkDynamicDataFlowVoById(this.siteURL, row.workDynamicData.id).then(res => {
        this.flowFalg = true
        let actionAry = res.data.actionList.filter(a => {
          return a.actionId === action.actionId
        })
        if (actionAry.length === 0) {
          this.$message.info('当前作品流程发生变化，请刷新后重试')
          this.initView()
          return
        }
        this.currentFlow.action = action
        this.currentFlow.row = res.data
        this.pushFlow.pushMsg = ''
        let data = res.data.workDynamicData.data
        this.form = JSON.parse(data)
        this.form.siteId = res.data.workDynamicData.siteId
        this.form.userId = res.data.workDynamicData.userId
        this.form.id = res.data.workDynamicData.id
        this.form.divisionId = res.data.workDynamicData.divisionId
        this.form.categoryId = res.data.workDynamicData.categoryId
        this.form.participantId = res.data.workDynamicData.participantId
      })
      this.$refs.workFormCheck.hideBuuton()
    },
    deleteTemporaryWork (item) {
      removeTemporary(this.siteURL, item.id).then(res => {
        this.getWorkType()
      })
    },
    getTemporaryWorkList () {
      listTemporary(this.siteURL, {
        siteId: this.siteId,
        userId: this.$store.state.user.userId,
        status: this.status
      }).then(res => {
        this.temporaryWorkList = res.rows
      })
    },
    back (falg) {
      this.pageShow = falg
      this.form = {}
    },
    updataWorkStatus (falg) {
      console.log('falg: ' + falg)
      this.updataWorkFalg = falg
    },
    getTypeName (id) {
      let type = this.workTypeList.filter((type) => {
        return type.id === id
      })
      return type[0].name
    },
    getWorkType () {
      listWorksCategoryConf(this.baseURL, {
        siteId: this.siteId
      }).then(async res => {
        this.workTypeList = res.rows
        await this.getWorkList()
        await this.getTemporaryWorkList()
      })
    },
    editWork (item, temporaryFalg) {
      this.temporaryFalg = temporaryFalg
      conditionByParticipantData(this.baseURL, {
        siteId: this.siteId,
        userId: this.$store.state.user.userId,
        status: this.status
      }).then(res => {
        if (res.data.length === 0) {
          this.$alert('请先报名参赛！', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showClose: false
          }).then(() => {
            this.$router.push({
              path: '/preliminaryApply'
            })
          }).catch(() => {
          })
        } else {
          if (item) {
            let work = {...item.workDynamicData}
            let editFalg = true
            if (item.nodeList) {
              item.nodeList.forEach(node => {
                if (node.nodeType === 'file-check') {
                  editFalg = false
                }
              })
            }
            this.workEditFalg = temporaryFalg ? false : editFalg
            let workForm = JSON.parse(work.data)
            workForm.siteId = work.siteId
            workForm.userId = work.userId
            workForm.id = work.id
            workForm.divisionId = work.divisionId
            workForm.categoryId = work.categoryId
            workForm.participantId = res.data[0].id
            workForm.competitionProject = res.data[0].competitionProject
            this.form = workForm
            this.pageShow = true
          } else {
            this.workEditFalg = false
            this.form.categoryId = this.workTypeList[0].id
            this.form.participantId = res.data[0].id
            // this.form.competitionProject = res.data[0].competitionProject
            this.pageShow = true
            this.form.divisionId = res.data[0].divisionId
          }
        }
      })
    },
    deleteWork (item) {
      this.$confirm(`确认删除作品编号为：${item.id}的作品吗`, '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        return delData(this.siteURL, item.id).then(res => {
          this.$message.success('删除成功')
          this.getWorkType()
        })
      }).catch(() => {
        this.$message.error('删除失败')
        this.getWorkType()
      })
    },
    getWorkList () {
      listData(this.siteURL, {
        siteId: this.siteId,
        userId: this.$store.state.user.userId,
        status: this.status
      }).then(res => {
        this.list = []
        res.rows.forEach(row => {
          this.list.push(row)
        })
      })
    }
  }
}
</script>

<style scoped>
.action-item {
  text-align: right;
  width: 80%;
  margin: 1rem auto;
  font-size: 15px;
  /* cursor: pointer; */
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
}
.workList {
  /* height: 550px; */
  overflow-y: scroll;
}

.work-item {
  width: 80%;
  margin: 1rem auto;
  /* cursor: pointer; */
  border-radius: .5rem;
  background-color: #fff;
  padding: 0.5rem 1rem;
}

.work-item:hover {
  box-shadow: 0 2px 12px 0 rgba(100, 100, 100, 0.1);
}

p {
  margin: 0;
  line-height: 40px;
}

.subText {
  font-size: 13px;
  color: #999;
}
</style>
<style>
.workList1 .el-col .el-button {
  margin-top: 12px;
}
.enWorkList-el-divider-Div .el-divider__text {
  background: #f8f8f8 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/my/components/workList.vue